import React from 'react';
import { useSelector } from 'react-redux';

import { numberOfDays } from 'utils/formatter/number-of-days';
import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import ListItem from 'components/ListItem';
import { makeSelectWithholdingPeriodDays } from './selectors';

export interface Props {
    productId: FertilizerProductId;
}

export default function FertilizerEventWithholdingPeriodListItem(
    props: Props
): React.ReactElement {
    const withholdingPeriod = useSelector((state: AppState) =>
        makeSelectWithholdingPeriodDays()(state, props)
    );

    return (
        <ListItem
            value={
                typeof withholdingPeriod === 'number'
                    ? numberOfDays(withholdingPeriod)
                    : ''
            }
            description="Withholding period"
        />
    );
}
